<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <!-- inner wrapper used for centering -->
    <div>
      <!-- title above form card -->
      <h1 class="px-4 text-primary fade-in-up-enter-active animation-slowest">{{ greeting }}</h1>
      <h3 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200">{{ greetingQuestion }}</h3>
      <!-- form card -->
      <base-card inner-class="w-100" color="alternate" :outer-padding="true">
        <base-form @submit="onSubmit">
          <!-- inputs -->
          <base-input name="FirstName" 
            v-model:value="lead.contact.FirstName" :validator="v$.contact.FirstName">
            Voornaam
          </base-input>
          <base-input name="LastName" 
            v-model:value="lead.contact.LastName" :validator="v$.contact.LastName">
            Achternaam
          </base-input>
          <base-input name="Email" type="email" placeholder="test@example.com" 
            v-model:value="lead.contact.Email" :validator="v$.contact.Email" :debounce="700" :debounce-touch-only="true">
            E-mailadres
          </base-input>
          <base-input name="Phone" type="phone" placeholder="+316 00 00 00 00" 
            v-model:value="lead.contact.Phone" :validator="v$.contact.Phone">
            Telefoonnummer
          </base-input>
          <!-- buttons -->
          <button-row class="mt-4">
            <base-button class="ms-auto" icon="bi-arrow-right" type="submit" :disabled="v$.contact.$invalid">Volgende</base-button>
          </button-row>
        </base-form>
      <!-- form card end -->
      </base-card>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"

  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    computed: {
      greetingQuestion() {
        if (this.uiStore.isExistingCustomer) {
          return 'Kloppen deze gegevens?';
        } else {
          return 'Hoe kunnen we u bereiken?';
        }
      },
      greeting() {
        if (this.uiStore.isExistingCustomer) {
          if (this.lead.contact.FirstName) {
            return 'Hallo '+this.lead.contact.FirstName+'!';
          } else {
            return 'Hallo!';
          }
        } else {
          return 'Hallo!'
        }
      }
    },
    methods: {
      touchAndValidate() {
        this.v$.contact.$touch();
        return !this.v$.contact.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
    }
  }
</script>

<style lang="scss">
</style>